import React, { useEffect } from 'react';
import styles from './CaptureForm.module.scss';
import Select from 'component/atom/forms/select/select/Select';
import { useFormikContext } from 'formik';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import Input from 'component/atom/forms/input/input/Input';
import Button from 'component/atom/forms/button/Button';
import Toggle from 'component/atom/forms/toggle/Toggle';
import RadioGroup from 'component/atom/forms/radio-group/RadioGroup';
import EntireUserReply from './components/EntireUserReply';
import Entities from './components/Entities';

const CaptureForm = ({ data, isFetching }) => {
  const formik = useFormikContext();

  const radioOptions = [
    { label: 'Entire User Reply', value: '0' },
    { label: 'Entities', value: '1' },
  ];

  useEffect(() => {
    if (data?.data?.items) {
      const selectedVariable = data?.data?.items.find(
        (item) => item.variableId == formik.values.variableId
      )?.variableName;

      formik.setFieldValue('variableLabel', selectedVariable || '');
    }
  }, [formik.values.variableId, data]);

  return (
    <form
      className={styles['capture-form']}
      onSubmit={formik.handleSubmit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      <RadioGroup
        options={radioOptions}
        name='entitiesType'
        selectedValue={formik.values.entitiesType}
        onChange={(e) => {
          formik.setFieldValue('entitiesType', e.target.value);
        }}
        error={formik.errors.entitiesType}
        touched={formik.touched.entitiesType}
      />
      {formik.values.entitiesType === '0' ? (
        <EntireUserReply formik={formik} data={data} isFetching={isFetching} />
      ) : (
        <Entities formik={formik} data={data} />
      )}
    </form>
  );
};

export default CaptureForm;
